<script>
import BaseCounterList from './BaseCounterList';

export default {
  name: 'question-bicycle-use-outside-home-at-time',
  extends: BaseCounterList,
  props: {
    optionsConfig: {
      type: Object,
      default: function () {
        return {
          options: {
            bicycleUseOutsideHomeAtTime: {
              max: this.formData.bicycles.length,
              min: 1,
            },
          },
        };
      },
    },
  },
  computed: {
    shouldQuestionRender () {
      return this.formData.bicycles.length > 1;
    },
  },
  created () {
    const bicycleCount = this.formData.bicycles.length;
    const countRange = this.optionsConfig.options.bicycleUseOutsideHomeAtTime;

    if (bicycleCount < this.sessionData.bicycleUseOutsideHomeAtTime) {
      this.questionData.bicycleUseOutsideHomeAtTime = countRange.max;
    }
  },
};
</script>
